const complianceItems = [
  {
    icon: 'ri-ship-line',
    title: '关务合规',
    description: '提交前校验 + 回执留痕 + 单证归档',
    color: 'from-[#14B8A6] to-[#0D9488]'
  },
  {
    icon: 'ri-file-list-3-line',
    title: '税务合规',
    description: '三流对齐 + 核销链路 + 差异可追溯',
    color: 'from-[#0D9488] to-[#14B8A6]'
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: '外汇合规',
    description: '收款证据链归集 + 权限与导出留痕',
    color: 'from-[#14B8A6] to-[#0D9488]'
  }
];

export default function Compliance() {
  const handleNavigate = () => {
    window.REACT_APP_NAVIGATE('/compliance');
  };

  return (
    <section id="compliance" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            合规与安全
          </h2>
          <p className="text-gray-600 text-lg">
            按风险域管理
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {complianceItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#14B8A6]"
            >
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${item.color} flex items-center justify-center mb-6`}>
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>

              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {item.title}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleNavigate}
            className="inline-flex items-center gap-2 px-8 h-12 bg-white border-2 border-[#14B8A6] text-[#14B8A6] font-medium rounded-full hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer shadow-sm hover:shadow-md"
          >
            查看合规与安全
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}